var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _path0, _g6, _path1, _g7, _path10, _g8, _path11, _g9, _path12, _path13, _g0, _path14, _path15, _g1, _path16, _path17, _g10, _path18, _path19, _g11, _path20, _g12, _path21, _g13, _g14, _path22, _path23, _g15, _path24, _path25, _g16, _path26, _g17, _path27, _g18, _g19, _path28, _path29, _g20, _path30, _path31, _g21, _path32, _g22, _path33, _g23, _path34, _g24, _g25, _path35, _g26, _g27, _path36, _g28, _path37, _path38, _g29, _path39, _path40, _g30, _path41, _g31, _path42, _path43, _g32, _path44, _path45, _g33, _path46, _g34, _path47, _path48, _g35, _path49, _g36, _path50, _g37, _g38, _path51, _path52, _g39, _path53, _g40, _path54, _g41, _g42, _path55, _path56, _g43, _path57, _g44, _path58, _path59, _g45, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiraffeSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_182031)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.53 320C213.947 320 258.06 314.026 258.06 306.657C258.06 299.288 213.947 293.313 159.53 293.313C105.113 293.313 61 299.288 61 306.657C61 314.026 105.113 320 159.53 320Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.076 221.247C100.076 221.247 128.21 181.999 143.6 171.6L132.118 155.492C115.165 166.972 83.6641 209.947 83.6641 209.947L100.076 221.247Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 155,
    width: 61,
    height: 67
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.076 221.247C100.076 221.247 128.21 181.999 143.6 171.6L132.118 155.492C115.165 166.972 83.6641 209.947 83.6641 209.947L100.076 221.247Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.743 226.897C103.743 226.897 141.977 180.495 157.306 170.157L148.409 161.142C131.456 172.622 95.3867 219.985 95.3867 219.985L103.743 226.897Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 155,
    width: 61,
    height: 67
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.076 221.247C100.076 221.247 128.21 181.999 143.6 171.6L132.118 155.492C115.165 166.972 83.6641 209.947 83.6641 209.947L100.076 221.247Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5934 191.735C101.938 193.358 105.184 192.697 106.807 190.353C108.43 188.009 107.769 184.763 105.425 183.2C103.08 181.578 99.8338 182.239 98.2107 184.583C96.5876 186.927 97.1887 190.173 99.5934 191.735Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 155,
    width: 61,
    height: 67
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.076 221.247C100.076 221.247 128.21 181.999 143.6 171.6L132.118 155.492C115.165 166.972 83.6641 209.947 83.6641 209.947L100.076 221.247Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.217 207.243C103.141 208.505 105.666 208.084 106.868 206.281C108.071 204.478 107.53 201.954 105.606 200.692C103.682 199.429 101.157 199.85 99.9549 201.653C98.7526 203.456 99.3537 205.981 101.217 207.243Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 155,
    width: 61,
    height: 67
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.076 221.247C100.076 221.247 128.21 181.999 143.6 171.6L132.118 155.492C115.165 166.972 83.6641 209.947 83.6641 209.947L100.076 221.247Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.179 181.878C114.562 182.84 116.486 182.479 117.447 181.037C118.409 179.654 118.049 177.731 116.606 176.769C115.223 175.807 113.299 176.168 112.338 177.611C111.376 179.053 111.736 180.916 113.179 181.878Z",
    fill: "#673620"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9636 209.707C69.2953 217.641 69.5959 237.896 83.2422 237.235C87.9914 236.995 93.5822 230.864 95.3256 226.356C95.2654 228.159 96.0469 232.667 98.8123 231.165C99.8944 230.564 101.157 226.116 100.315 220.887C96.6481 215.417 89.1937 209.707 83.9636 209.707Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 209,
    width: 29,
    height: 29
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9636 209.707C69.2953 217.641 69.5959 237.896 83.2422 237.235C87.9914 236.995 93.5822 230.864 95.3256 226.356C95.2654 228.159 96.0469 232.667 98.8123 231.165C99.8944 230.564 101.157 226.116 100.315 220.887C96.6481 215.417 89.1937 209.707 83.9636 209.707Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2125 216.198C98.3328 216.078 94.1848 220.105 92.9223 223.411C87.9928 235.311 76.3904 239.879 71.4609 226.897C72.0621 238.016 83.5442 242.223 90.0368 240.901C96.8299 239.459 101.94 233.568 103.863 226.957C104.645 224.312 105.006 221.307 104.104 218.602L98.2125 216.198Z",
    fill: "#301007"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.926 221.247C218.926 221.247 190.792 181.999 175.402 171.6L186.884 155.492C203.837 166.972 235.338 209.947 235.338 209.947L218.926 221.247Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 155,
    width: 61,
    height: 67
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M218.926 221.247C218.926 221.247 190.792 181.999 175.402 171.6L186.884 155.492C203.837 166.972 235.338 209.947 235.338 209.947L218.926 221.247Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.259 226.897C215.259 226.897 177.025 180.495 161.695 170.157L170.592 161.142C187.545 172.622 223.615 219.985 223.615 219.985L215.259 226.897Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 155,
    width: 61,
    height: 67
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M218.926 221.247C218.926 221.247 190.792 181.999 175.402 171.6L186.884 155.492C203.837 166.972 235.338 209.947 235.338 209.947L218.926 221.247Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.706 192.998C217.241 194.38 214.055 193.539 212.673 191.014C211.29 188.55 212.192 185.364 214.657 183.982C217.121 182.6 220.307 183.441 221.69 185.966C223.073 188.49 222.171 191.615 219.706 192.998Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 155,
    width: 61,
    height: 67
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.926 221.247C218.926 221.247 190.792 181.999 175.402 171.6L186.884 155.492C203.837 166.972 235.338 209.947 235.338 209.947L218.926 221.247Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.762 208.324C214.778 209.466 212.253 208.805 211.231 206.942C210.149 205.079 210.93 202.614 212.914 201.472C214.898 200.33 217.423 200.992 218.445 202.855C219.527 204.778 218.745 207.182 216.762 208.324Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 155,
    width: 61,
    height: 67
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.926 221.247C218.926 221.247 190.792 181.999 175.402 171.6L186.884 155.492C203.837 166.972 235.338 209.947 235.338 209.947L218.926 221.247Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.964 182.119C205.462 182.96 203.598 182.419 202.756 180.977C201.915 179.474 202.456 177.611 203.959 176.83C205.462 175.988 207.325 176.529 208.167 177.972C208.948 179.414 208.407 181.277 206.964 182.119Z",
    fill: "#673620"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M235.095 209.707C249.763 217.641 249.463 237.896 235.816 237.235C231.067 236.995 225.476 230.864 223.733 226.356C223.793 228.159 223.012 232.667 220.246 231.165C219.164 230.564 217.902 226.116 218.743 220.887C222.35 215.417 229.865 209.707 235.095 209.707Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 209,
    width: 29,
    height: 29
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M235.095 209.707C249.763 217.641 249.463 237.896 235.816 237.235C231.067 236.995 225.476 230.864 223.733 226.356C223.793 228.159 223.012 232.667 220.246 231.165C219.164 230.564 217.902 226.116 218.743 220.887C222.35 215.417 229.865 209.707 235.095 209.707Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.789 216.198C220.669 216.078 224.817 220.105 226.079 223.411C231.009 235.311 242.611 239.879 247.541 226.897C246.94 238.016 235.457 242.223 228.965 240.901C222.172 239.459 217.062 233.568 215.138 226.957C214.357 224.312 213.996 221.307 214.898 218.602L220.789 216.198Z",
    fill: "#301007"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M224.155 254.125C218.684 254.966 211.11 252.802 204.136 247.573C198.846 243.546 193.917 237.716 190.49 229.902L183.637 233.328C187.965 242.344 193.977 248.896 200.349 253.343C209.126 259.414 218.504 261.397 225.117 260.135L224.155 254.125Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 229,
    width: 43,
    height: 32
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.155 254.125C218.684 254.966 211.11 252.802 204.136 247.573C198.846 243.546 193.917 237.716 190.49 229.902L183.637 233.328C187.965 242.344 193.977 248.896 200.349 253.343C209.126 259.414 218.504 261.397 225.117 260.135L224.155 254.125Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.122 237.355C188.745 240.12 191.391 242.645 193.615 244.869C199.807 250.999 206.961 255.447 215.196 257.491C217.421 258.032 219.705 258.693 222.05 258.753C222.23 258.753 222.711 259.354 222.831 259.474C223.553 260.075 224.274 260.556 225.055 260.977C227.34 262.239 229.805 262.84 232.39 262.72C237.92 262.54 242.489 259.354 246.096 255.147C247.298 253.764 248.441 252.322 249.583 250.819C250.004 250.218 250.484 249.557 250.905 248.956C250.965 248.896 251.266 248.415 251.386 248.535C251.627 248.836 251.086 249.857 250.965 250.158C250.304 251.901 249.523 253.524 248.621 255.147C244.894 261.758 239.002 266.747 231.488 267.408C228.121 267.709 224.695 267.168 221.629 265.785C220.006 265.064 218.563 263.742 216.94 263.141C214.054 262.059 210.928 261.938 208.043 260.796C198.965 257.13 190.369 250.098 185.379 241.322L187.122 237.355Z",
    fill: "#CE8710"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.457 263.621C219.828 262.539 214.718 255.928 220.609 251.78C228.364 246.251 235.939 250.578 239.606 247.934C239.245 249.917 237.081 252.201 232.212 253.884C231.731 254.064 234.196 253.824 234.616 253.764C237.141 253.343 239.185 251.901 240.929 250.158C244.896 246.251 246.519 246.912 246.459 246.972C243.033 251.3 241.65 255.627 240.267 257.25C234.857 263.681 229.867 264.943 224.457 263.621Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 246,
    width: 30,
    height: 19
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.457 263.621C219.828 262.539 214.718 255.928 220.609 251.78C228.364 246.251 235.939 250.578 239.606 247.934C239.245 249.917 237.081 252.201 232.212 253.884C231.731 254.064 234.196 253.824 234.616 253.764C237.141 253.343 239.185 251.901 240.929 250.158C244.896 246.251 246.519 246.912 246.459 246.972C243.033 251.3 241.65 255.627 240.267 257.25C234.857 263.681 229.867 264.943 224.457 263.621Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.857 237.596C194.879 239.88 196.743 242.104 198.306 244.027C202.634 249.376 207.985 253.463 214.417 255.928C216.16 256.589 217.964 257.31 219.767 257.551C219.888 257.551 220.248 258.092 220.308 258.152C220.789 258.693 221.39 259.113 221.931 259.534C223.615 260.736 225.599 261.457 227.642 261.638C232.091 262.059 236.119 260.075 239.425 257.19C240.507 256.228 241.589 255.267 242.611 254.245C243.032 253.824 243.453 253.343 243.874 252.923C243.934 252.862 244.234 252.562 244.295 252.622C244.415 252.862 243.874 253.644 243.814 253.824C243.152 255.086 242.311 256.288 241.409 257.43C237.802 262.119 232.512 265.364 226.44 265.124C223.735 265.004 221.03 264.282 218.685 262.9C217.423 262.179 216.461 261.037 215.138 260.376C212.914 259.234 210.449 258.873 208.225 257.671C201.312 253.944 195.06 247.693 191.934 240.361L193.857 237.596Z",
    fill: "#301007"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.347 306.537C148.347 306.537 147.686 269.031 154.298 249.918L114.802 236.334C106.627 260.196 106.566 306.897 106.566 306.897L148.347 306.537Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 236,
    width: 49,
    height: 71
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.347 306.537C148.347 306.537 147.686 269.031 154.298 249.918L114.802 236.334C106.627 260.196 106.566 306.897 106.566 306.897L148.347 306.537Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.556 306.837C111.796 294.456 113.059 260.196 119.732 240.902L153.457 252.502C153.697 251.601 153.998 250.759 154.298 249.918L114.802 236.334C106.627 260.196 106.566 306.897 106.566 306.897L111.556 306.837Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 236,
    width: 49,
    height: 71
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.347 306.537C148.347 306.537 147.686 269.031 154.298 249.918L114.802 236.334C106.627 260.196 106.566 306.897 106.566 306.897L148.347 306.537Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.418 280.812C130.734 280.571 129.171 281.713 128.931 283.396C128.69 285.079 129.833 286.642 131.516 286.882C133.199 287.123 134.762 285.981 135.003 284.298C135.303 282.615 134.101 281.052 132.418 280.812ZM117.87 264.223C113.962 264.223 110.836 267.348 110.836 271.255C110.836 275.162 114.022 278.287 117.87 278.287C121.777 278.287 124.903 275.162 124.903 271.255C124.903 267.348 121.777 264.223 117.87 264.223Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 264,
    width: 26,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 264,
    width: 26,
    height: 23
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.418 280.812C130.734 280.571 129.171 281.713 128.931 283.396C128.69 285.079 129.833 286.642 131.516 286.882C133.199 287.123 134.762 285.981 135.003 284.298C135.303 282.615 134.101 281.052 132.418 280.812ZM117.87 264.223C113.962 264.223 110.836 267.348 110.836 271.255C110.836 275.162 114.022 278.287 117.87 278.287C121.777 278.287 124.903 275.162 124.903 271.255C124.903 267.348 121.777 264.223 117.87 264.223Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.347 306.537C148.347 306.537 147.686 269.031 154.298 249.918L114.802 236.334C106.627 260.196 106.566 306.897 106.566 306.897L148.347 306.537Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.556 306.837C111.796 294.456 113.059 260.196 119.732 240.902L153.457 252.502C153.697 251.601 153.998 250.759 154.298 249.918L114.802 236.334C106.627 260.196 106.566 306.897 106.566 306.897L111.556 306.837Z",
    fill: "#C3A088"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M107.169 307.678C106.388 307.678 105.666 307.258 105.245 306.596C104.825 305.935 104.825 305.094 105.185 304.373C108.913 297.821 118.892 293.013 129.051 293.013C139.512 293.013 147.026 298.062 149.791 304.914C150.032 305.515 149.972 306.236 149.611 306.777C149.25 307.318 148.649 307.618 147.988 307.618C139.932 307.678 115.886 307.678 107.169 307.678Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 293,
    width: 46,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.169 307.678C106.388 307.678 105.666 307.258 105.245 306.596C104.825 305.935 104.825 305.094 105.185 304.373C108.913 297.821 118.892 293.013 129.051 293.013C139.512 293.013 147.026 298.062 149.791 304.914C150.032 305.515 149.972 306.236 149.611 306.777C149.25 307.318 148.649 307.618 147.988 307.618C139.932 307.678 115.886 307.678 107.169 307.678Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.561 302.329C104.102 303.171 105.064 303.712 106.146 303.712C116.365 303.712 140.231 303.712 149.549 303.651C150.391 303.651 151.173 303.291 151.653 302.69C151.954 303.11 152.194 303.531 152.435 303.952C152.856 304.733 152.856 305.695 152.375 306.476C151.894 307.258 151.052 307.739 150.09 307.739C140.532 307.799 115.884 307.799 105.424 307.799C104.282 307.799 103.2 307.138 102.719 306.176C102.178 305.154 102.298 304.012 103.02 303.11C103.2 302.75 103.38 302.57 103.561 302.329Z",
    fill: "#301007"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.651 306.537C170.651 306.537 171.312 269.031 164.699 249.918L204.195 236.334C212.371 260.196 212.431 306.897 212.431 306.897L170.651 306.537Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 236,
    width: 49,
    height: 71
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M170.651 306.537C170.651 306.537 171.312 269.031 164.699 249.918L204.195 236.334C212.371 260.196 212.431 306.897 212.431 306.897L170.651 306.537Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.442 306.837C207.201 294.456 205.939 260.196 199.266 240.902L165.541 252.502C165.3 251.601 165 250.759 164.699 249.918L204.195 236.334C212.371 260.196 212.431 306.897 212.431 306.897L207.442 306.837Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 236,
    width: 49,
    height: 71
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.651 306.537C170.651 306.537 171.312 269.031 164.699 249.918L204.195 236.334C212.371 260.196 212.431 306.897 212.431 306.897L170.651 306.537Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.258 280.812C186.941 280.571 188.504 281.713 188.744 283.396C188.985 285.079 187.843 286.642 186.159 286.882C184.476 287.123 182.913 285.981 182.673 284.298C182.432 282.615 183.574 281.052 185.258 280.812ZM199.806 264.223C203.713 264.223 206.839 267.348 206.839 271.255C206.839 275.162 203.713 278.287 199.806 278.287C195.898 278.287 192.772 275.162 192.772 271.255C192.772 267.348 195.898 264.223 199.806 264.223Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 264,
    width: 25,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 264,
    width: 25,
    height: 23
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M185.261 280.812C186.945 280.571 188.508 281.713 188.748 283.396C188.989 285.079 187.846 286.642 186.163 286.882C184.48 287.123 182.917 285.981 182.676 284.298C182.436 282.615 183.578 281.052 185.261 280.812ZM199.81 264.223C203.717 264.223 206.843 267.348 206.843 271.255C206.843 275.162 203.717 278.287 199.81 278.287C195.902 278.287 192.776 275.162 192.776 271.255C192.776 267.348 195.902 264.223 199.81 264.223Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.655 306.537C170.655 306.537 171.316 269.031 164.703 249.918L204.199 236.334C212.375 260.196 212.435 306.897 212.435 306.897L170.655 306.537Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.446 306.837C207.205 294.456 205.943 260.196 199.27 240.902L165.545 252.502C165.304 251.601 165.004 250.759 164.703 249.918L204.199 236.334C212.375 260.196 212.435 306.897 212.435 306.897L207.446 306.837Z",
    fill: "#301007"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.829 307.678C212.61 307.678 213.332 307.258 213.753 306.596C214.174 305.935 214.174 305.094 213.813 304.373C210.086 297.821 200.106 293.013 189.947 293.013C179.487 293.013 171.972 298.062 169.207 304.914C168.966 305.515 169.026 306.236 169.387 306.777C169.748 307.318 170.349 307.618 171.01 307.618C179.126 307.678 203.112 307.678 211.829 307.678Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 293,
    width: 46,
    height: 15
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M211.829 307.678C212.61 307.678 213.332 307.258 213.753 306.596C214.174 305.935 214.174 305.094 213.813 304.373C210.086 297.821 200.106 293.013 189.947 293.013C179.487 293.013 171.972 298.062 169.207 304.914C168.966 305.515 169.026 306.236 169.387 306.777C169.748 307.318 170.349 307.618 171.01 307.618C179.126 307.678 203.112 307.678 211.829 307.678Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.437 302.329C214.896 303.171 213.934 303.712 212.852 303.712C202.632 303.712 178.766 303.712 169.448 303.651C168.606 303.651 167.825 303.291 167.344 302.69C167.043 303.11 166.803 303.531 166.562 303.952C166.142 304.733 166.142 305.695 166.622 306.476C167.103 307.258 167.945 307.739 168.907 307.739C178.465 307.799 203.113 307.799 213.573 307.799C214.715 307.799 215.797 307.138 216.278 306.176C216.819 305.154 216.639 304.012 215.978 303.11C215.857 302.75 215.617 302.57 215.437 302.329Z",
    fill: "#301007"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 95,
    height: 117
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.878 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 239.519 116.609 252.081 123.522 261.818C119.615 253.043 117.39 242.945 117.39 232.186C117.39 214.756 123.041 183.621 131.878 156.514Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 95,
    height: 117
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.125 156.514H192.896C200.591 182.479 206.542 208.264 206.542 225.815C206.542 239.519 202.394 252.081 195.481 261.818C199.389 253.043 201.613 242.945 201.613 232.186C201.613 214.756 195.962 183.621 187.125 156.514Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 95,
    height: 117
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.398 239.94C128.753 239.94 126.588 242.164 126.588 244.929C126.588 247.693 128.753 249.917 131.398 249.917C134.043 249.917 136.207 247.693 136.207 244.929C136.207 242.164 134.043 239.94 131.398 239.94ZM188.628 240.24C191.213 240.24 193.257 242.164 193.257 244.568C193.257 246.972 191.153 248.896 188.628 248.896C186.043 248.896 183.999 246.972 183.999 244.568C183.939 242.224 186.043 240.24 188.628 240.24ZM200.711 222.87C203.597 222.87 205.881 225.214 205.881 228.039C205.881 230.864 203.537 233.208 200.711 233.208C197.826 233.208 195.541 230.864 195.541 228.039C195.481 225.154 197.826 222.87 200.711 222.87ZM116.85 221.367C113.964 221.367 111.68 223.651 111.68 226.536C111.68 229.361 114.024 231.705 116.85 231.705C119.735 231.705 122.02 229.421 122.02 226.536C122.02 223.651 119.675 221.367 116.85 221.367ZM190.071 212.111C191.754 212.111 193.137 213.494 193.137 215.176C193.137 216.859 191.754 218.242 190.071 218.242C188.388 218.242 187.005 216.859 187.005 215.176C187.005 213.494 188.328 212.111 190.071 212.111ZM127.791 209.647C126.108 209.647 124.725 211.029 124.725 212.712C124.725 214.395 126.108 215.778 127.791 215.778C129.474 215.778 130.857 214.395 130.857 212.712C130.857 210.969 129.474 209.647 127.791 209.647ZM199.148 187.829C203.056 187.829 206.182 190.954 206.182 194.861C206.182 198.708 203.056 201.893 199.148 201.893C195.241 201.893 192.115 198.768 192.115 194.861C192.115 190.954 195.241 187.829 199.148 187.829ZM119.435 187.829C115.527 187.829 112.401 190.954 112.401 194.861C112.401 198.708 115.527 201.893 119.435 201.893C123.342 201.893 126.468 198.768 126.468 194.861C126.468 190.954 123.342 187.829 119.435 187.829ZM186.404 178.332C188.087 178.332 189.47 179.714 189.47 181.397C189.47 183.08 188.087 184.463 186.404 184.463C184.721 184.463 183.338 183.08 183.338 181.397C183.338 179.714 184.721 178.332 186.404 178.332ZM132.179 178.332C130.496 178.332 129.113 179.714 129.113 181.397C129.113 183.08 130.496 184.463 132.179 184.463C133.862 184.463 135.245 183.08 135.245 181.397C135.245 179.714 133.862 178.332 132.179 178.332Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 178,
    width: 95,
    height: 72
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 178,
    width: 96,
    height: 72
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M131.398 239.94C128.753 239.94 126.588 242.164 126.588 244.929C126.588 247.693 128.753 249.917 131.398 249.917C134.043 249.917 136.207 247.693 136.207 244.929C136.207 242.164 134.043 239.94 131.398 239.94ZM188.628 240.24C191.213 240.24 193.257 242.164 193.257 244.568C193.257 246.972 191.153 248.896 188.628 248.896C186.043 248.896 183.999 246.972 183.999 244.568C183.939 242.224 186.043 240.24 188.628 240.24ZM200.711 222.87C203.597 222.87 205.881 225.214 205.881 228.039C205.881 230.864 203.537 233.208 200.711 233.208C197.826 233.208 195.541 230.864 195.541 228.039C195.481 225.154 197.826 222.87 200.711 222.87ZM116.85 221.367C113.964 221.367 111.68 223.651 111.68 226.536C111.68 229.361 114.024 231.705 116.85 231.705C119.735 231.705 122.02 229.421 122.02 226.536C122.02 223.651 119.675 221.367 116.85 221.367ZM190.071 212.111C191.754 212.111 193.137 213.494 193.137 215.176C193.137 216.859 191.754 218.242 190.071 218.242C188.388 218.242 187.005 216.859 187.005 215.176C187.005 213.494 188.328 212.111 190.071 212.111ZM127.791 209.647C126.108 209.647 124.725 211.029 124.725 212.712C124.725 214.395 126.108 215.778 127.791 215.778C129.474 215.778 130.857 214.395 130.857 212.712C130.857 210.969 129.474 209.647 127.791 209.647ZM199.148 187.829C203.056 187.829 206.182 190.954 206.182 194.861C206.182 198.708 203.056 201.893 199.148 201.893C195.241 201.893 192.115 198.768 192.115 194.861C192.115 190.954 195.241 187.829 199.148 187.829ZM119.435 187.829C115.527 187.829 112.401 190.954 112.401 194.861C112.401 198.708 115.527 201.893 119.435 201.893C123.342 201.893 126.468 198.768 126.468 194.861C126.468 190.954 123.342 187.829 119.435 187.829ZM186.404 178.332C188.087 178.332 189.47 179.714 189.47 181.397C189.47 183.08 188.087 184.463 186.404 184.463C184.721 184.463 183.338 183.08 183.338 181.397C183.338 179.714 184.721 178.332 186.404 178.332ZM132.179 178.332C130.496 178.332 129.113 179.714 129.113 181.397C129.113 183.08 130.496 184.463 132.179 184.463C133.862 184.463 135.245 183.08 135.245 181.397C135.245 179.714 133.862 178.332 132.179 178.332Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.125 156.514H192.896C200.591 182.479 206.542 208.264 206.542 225.815C206.542 239.519 202.394 252.081 195.481 261.818C199.389 253.043 201.613 242.945 201.613 232.186C201.613 214.756 195.962 183.621 187.125 156.514Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 178,
    width: 95,
    height: 72
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 178,
    width: 96,
    height: 72
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.398 239.94C128.753 239.94 126.588 242.164 126.588 244.929C126.588 247.693 128.753 249.917 131.398 249.917C134.043 249.917 136.207 247.693 136.207 244.929C136.207 242.164 134.043 239.94 131.398 239.94ZM188.628 240.24C191.213 240.24 193.257 242.164 193.257 244.568C193.257 246.972 191.153 248.896 188.628 248.896C186.043 248.896 183.999 246.972 183.999 244.568C183.939 242.224 186.043 240.24 188.628 240.24ZM200.711 222.87C203.597 222.87 205.881 225.214 205.881 228.039C205.881 230.864 203.537 233.208 200.711 233.208C197.826 233.208 195.541 230.864 195.541 228.039C195.481 225.154 197.826 222.87 200.711 222.87ZM116.85 221.367C113.964 221.367 111.68 223.651 111.68 226.536C111.68 229.361 114.024 231.705 116.85 231.705C119.735 231.705 122.02 229.421 122.02 226.536C122.02 223.651 119.675 221.367 116.85 221.367ZM190.071 212.111C191.754 212.111 193.137 213.494 193.137 215.176C193.137 216.859 191.754 218.242 190.071 218.242C188.388 218.242 187.005 216.859 187.005 215.176C187.005 213.494 188.328 212.111 190.071 212.111ZM127.791 209.647C126.108 209.647 124.725 211.029 124.725 212.712C124.725 214.395 126.108 215.778 127.791 215.778C129.474 215.778 130.857 214.395 130.857 212.712C130.857 210.969 129.474 209.647 127.791 209.647ZM199.148 187.829C203.056 187.829 206.182 190.954 206.182 194.861C206.182 198.708 203.056 201.893 199.148 201.893C195.241 201.893 192.115 198.768 192.115 194.861C192.115 190.954 195.241 187.829 199.148 187.829ZM119.435 187.829C115.527 187.829 112.401 190.954 112.401 194.861C112.401 198.708 115.527 201.893 119.435 201.893C123.342 201.893 126.468 198.768 126.468 194.861C126.468 190.954 123.342 187.829 119.435 187.829ZM186.404 178.332C188.087 178.332 189.47 179.714 189.47 181.397C189.47 183.08 188.087 184.463 186.404 184.463C184.721 184.463 183.338 183.08 183.338 181.397C183.338 179.714 184.721 178.332 186.404 178.332ZM132.179 178.332C130.496 178.332 129.113 179.714 129.113 181.397C129.113 183.08 130.496 184.463 132.179 184.463C133.862 184.463 135.245 183.08 135.245 181.397C135.245 179.714 133.862 178.332 132.179 178.332Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.878 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 239.519 116.609 252.081 123.522 261.818C119.615 253.043 117.39 242.945 117.39 232.186C117.39 214.756 123.041 183.621 131.878 156.514Z",
    fill: "#9D6E51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 95,
    height: 117
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M192.896 156.514H126.107C118.412 182.479 112.461 208.264 112.461 225.815C112.461 256.709 133.441 272.817 159.411 272.817C185.382 272.817 206.542 256.769 206.542 225.815C206.542 208.324 200.591 182.539 192.896 156.514Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.6 142.569C178.349 162.043 185.442 201.653 185.442 215.056C185.442 234.59 174.561 246.792 159.593 246.792C144.624 246.792 133.262 234.59 133.262 215.056C133.262 201.653 140.295 162.043 145.044 142.569H173.6Z",
    fill: "#EFD36F"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M140.175 11.0596L132.66 13.043L139.273 38.1069L146.787 36.1234L140.175 11.0596Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 11,
    width: 15,
    height: 28
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.175 11.0596L132.66 13.043L139.273 38.1069L146.787 36.1234L140.175 11.0596Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.59 13.7639L134.946 11.54L141.619 36.664L133.263 38.8278L126.59 13.7639Z",
    fill: "#CE8710"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.666 0C140.535 0 144.503 3.96694 144.503 8.83546C144.503 13.704 140.535 17.6709 135.666 17.6709C130.796 17.6709 126.829 13.704 126.829 8.83546C126.769 3.96694 130.736 0 135.666 0Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 0,
    width: 19,
    height: 18
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.666 0C140.535 0 144.503 3.96694 144.503 8.83546C144.503 13.704 140.535 17.6709 135.666 17.6709C130.796 17.6709 126.829 13.704 126.829 8.83546C126.769 3.96694 130.736 0 135.666 0Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.645 2.58406C135.005 3.00479 134.164 4.267 132.841 5.409C131.519 6.551 130.136 7.15205 129.775 6.79142C129.414 6.37068 130.256 5.10847 131.579 3.96647C132.901 2.76437 134.284 2.16332 134.645 2.58406Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 0,
    width: 19,
    height: 18
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.666 0C140.535 0 144.503 3.96694 144.503 8.83546C144.503 13.704 140.535 17.6709 135.666 17.6709C130.796 17.6709 126.829 13.704 126.829 8.83546C126.769 3.96694 130.736 0 135.666 0Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.242 4.26758C144.024 5.58989 144.505 7.15263 144.505 8.83557C144.505 13.7041 140.537 17.671 135.668 17.671C131.7 17.671 128.334 15.0264 127.191 11.4802C128.754 14.0647 131.58 15.7477 134.766 15.7477C139.635 15.7477 143.603 11.7807 143.603 6.91221C143.603 5.95052 143.483 5.10905 143.242 4.26758Z",
    fill: "#301007"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M178.828 11.0596L186.342 13.043L179.729 38.1069L172.215 36.1234L178.828 11.0596Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 11,
    width: 15,
    height: 28
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M178.828 11.0596L186.342 13.043L179.729 38.1069L172.215 36.1234L178.828 11.0596Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.414 13.7639L184.058 11.54L177.445 36.664L185.801 38.8278L192.414 13.7639Z",
    fill: "#CE8710"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M183.396 0C178.526 0 174.559 3.96694 174.559 8.83546C174.559 13.704 178.526 17.6709 183.396 17.6709C188.265 17.6709 192.233 13.704 192.233 8.83546C192.233 3.96694 188.265 0 183.396 0Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 0,
    width: 19,
    height: 18
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M183.396 0C178.526 0 174.559 3.96694 174.559 8.83546C174.559 13.704 178.526 17.6709 183.396 17.6709C188.265 17.6709 192.233 13.704 192.233 8.83546C192.233 3.96694 188.265 0 183.396 0Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.357 2.58406C183.997 3.00479 184.838 4.267 186.161 5.409C187.483 6.551 188.866 7.15205 189.227 6.79142C189.587 6.37068 188.746 5.10847 187.423 3.96647C186.101 2.76437 184.718 2.16332 184.357 2.58406Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 0,
    width: 19,
    height: 18
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M183.396 0C178.526 0 174.559 3.96694 174.559 8.83546C174.559 13.704 178.526 17.6709 183.396 17.6709C188.265 17.6709 192.233 13.704 192.233 8.83546C192.233 3.96694 188.265 0 183.396 0Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.762 4.26758C174.981 5.58989 174.5 7.15263 174.5 8.83557C174.5 13.7041 178.468 17.671 183.337 17.671C187.305 17.671 190.671 15.0264 191.813 11.4802C190.25 14.0647 187.425 15.7477 184.239 15.7477C179.369 15.7477 175.402 11.7807 175.402 6.91221C175.402 5.95052 175.522 5.10905 175.762 4.26758Z",
    fill: "#301007"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M184.837 41.3522C184.777 41.8932 185.258 40.3304 185.498 39.8496C186.04 38.8278 186.701 37.8661 187.302 36.9044C189.105 34.1997 191.029 31.495 193.073 28.9705C199.325 21.3372 207.381 15.3868 216.218 10.9991C218.682 9.79699 223.311 6.79173 226.017 8.83531C229.684 11.6603 226.498 22.2989 225.355 25.785C221.448 37.5055 207.741 49.7669 194.095 50.0074L184.837 41.3522Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 8,
    width: 44,
    height: 43
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M184.837 41.3522C184.777 41.8932 185.258 40.3304 185.498 39.8496C186.04 38.8278 186.701 37.8661 187.302 36.9044C189.105 34.1997 191.029 31.495 193.073 28.9705C199.325 21.3372 207.381 15.3868 216.218 10.9991C218.682 9.79699 223.311 6.79173 226.017 8.83531C229.684 11.6603 226.498 22.2989 225.355 25.785C221.448 37.5055 207.741 49.7669 194.095 50.0074L184.837 41.3522Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.454 4.74824C224.514 4.3275 224.995 5.40939 225.235 5.83013C225.656 6.55139 225.897 7.39286 226.137 8.17423C226.738 10.5784 227.099 13.163 226.678 15.5672C225.356 22.9 220.907 29.1509 215.857 34.5003C214.174 36.3035 212.431 37.9864 210.567 39.6092C208.463 41.4124 206.299 43.1554 203.834 44.4177C203.353 44.6581 201.97 45.5597 201.369 45.3793C200.528 45.1389 199.506 43.2156 198.905 42.6145C196.56 40.2704 193.614 38.5875 190.548 37.3853C189.947 37.1449 188.084 36.2434 187.422 36.5439C187.302 36.604 189.647 38.9481 189.767 39.1284C191.27 40.7512 192.713 42.4342 194.035 44.2373C196.259 47.1825 198.243 50.308 199.746 53.6739C200.047 54.335 200.768 57.3403 201.55 57.6408C202.331 57.9413 204.555 56.1983 205.097 55.8977C208.824 53.6739 212.31 51.2095 215.557 48.4447C224.274 41.0518 230.105 30.4131 231.608 19.1134C232.389 13.2832 231.548 6.55139 227.46 1.9834L224.454 4.74824Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 8,
    width: 44,
    height: 43
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M184.837 41.3522C184.777 41.8932 185.258 40.3304 185.498 39.8496C186.04 38.8278 186.701 37.8661 187.302 36.9044C189.105 34.1997 191.029 31.495 193.073 28.9705C199.325 21.3372 207.381 15.3868 216.218 10.9991C218.682 9.79699 223.311 6.79173 226.017 8.83531C229.684 11.6603 226.498 22.2989 225.355 25.785C221.448 37.5055 207.741 49.7669 194.095 50.0074L184.837 41.3522Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.82 48.0842C186.7 47.964 188.082 46.0406 188.203 45.9204C189.826 43.5763 191.629 41.4125 193.493 39.3088C198.603 33.4786 204.614 27.7686 211.407 24.2224C212.309 23.7416 213.271 23.2607 214.293 22.9001C216.277 22.1187 219.583 21.5778 218.862 24.9437C218.741 25.4846 218.561 25.9655 218.381 26.5064C216.938 30.1127 214.413 33.3584 211.768 36.0631C209.303 38.5875 206.358 40.571 203.412 42.3742C199.084 45.0188 194.455 46.5815 189.826 48.565L186.82 48.0842Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 22,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 22,
    width: 33,
    height: 27
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M186.824 48.0842C186.704 47.964 188.086 46.0406 188.206 45.9204C189.83 43.5763 191.633 41.4125 193.497 39.3088C198.607 33.4786 204.618 27.7686 211.411 24.2224C212.313 23.7416 213.275 23.2607 214.297 22.9001C216.281 22.1187 219.587 21.5778 218.866 24.9437C218.745 25.4846 218.565 25.9655 218.385 26.5064C216.942 30.1127 214.417 33.3584 211.772 36.0631C209.307 38.5875 206.361 40.571 203.416 42.3742C199.087 45.0188 194.459 46.5815 189.83 48.565L186.824 48.0842Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.841 41.3522C184.781 41.8932 185.262 40.3304 185.502 39.8496C186.043 38.8278 186.705 37.8661 187.306 36.9044C189.109 34.1997 191.033 31.495 193.077 28.9705C199.329 21.3372 207.385 15.3868 216.222 10.9991C218.686 9.79699 223.315 6.79173 226.021 8.83531C229.688 11.6603 226.501 22.2989 225.359 25.785C221.452 37.5055 207.745 49.7669 194.099 50.0074L184.841 41.3522Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.458 4.74824C224.518 4.3275 224.999 5.40939 225.239 5.83013C225.66 6.55139 225.901 7.39286 226.141 8.17423C226.742 10.5784 227.103 13.163 226.682 15.5672C225.36 22.9 220.911 29.1509 215.861 34.5003C214.178 36.3035 212.435 37.9864 210.571 39.6092C208.467 41.4124 206.303 43.1554 203.838 44.4177C203.357 44.6581 201.974 45.5597 201.373 45.3793C200.532 45.1389 199.51 43.2156 198.908 42.6145C196.564 40.2704 193.618 38.5875 190.552 37.3853C189.951 37.1449 188.088 36.2434 187.426 36.5439C187.306 36.604 189.651 38.9481 189.771 39.1284C191.274 40.7512 192.717 42.4342 194.039 44.2373C196.263 47.1825 198.247 50.308 199.75 53.6739C200.051 54.335 200.772 57.3403 201.554 57.6408C202.335 57.9413 204.559 56.1983 205.1 55.8977C208.828 53.6739 212.314 51.2095 215.561 48.4447C224.277 41.0518 230.109 30.4131 231.612 19.1134C232.393 13.2832 231.551 6.55139 227.464 1.9834L224.458 4.74824Z",
    fill: "#EEC18F"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.16 41.3527C134.22 41.8936 133.739 40.3309 133.499 39.85C132.958 38.8282 132.297 37.8666 131.695 36.9049C129.892 34.2001 127.968 31.4954 125.924 28.971C119.672 21.3977 111.557 15.3872 102.72 11.0596C100.255 9.85754 95.6259 6.85228 92.9207 8.89585C89.2536 11.7208 92.4398 22.3594 93.582 25.8455C97.4895 37.566 111.196 49.8275 124.842 50.0679L134.16 41.3527Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 8,
    width: 44,
    height: 43
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M134.16 41.3527C134.22 41.8936 133.739 40.3309 133.499 39.85C132.958 38.8282 132.297 37.8666 131.695 36.9049C129.892 34.2001 127.968 31.4954 125.924 28.971C119.672 21.3977 111.557 15.3872 102.72 11.0596C100.255 9.85754 95.6259 6.85228 92.9207 8.89585C89.2536 11.7208 92.4398 22.3594 93.582 25.8455C97.4895 37.566 111.196 49.8275 124.842 50.0679L134.16 41.3527Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5441 4.74886C94.4839 4.32813 94.003 5.41002 93.7626 5.83076C93.3417 6.55202 93.1013 7.39349 92.8608 8.17486C92.2597 10.5791 91.899 13.1636 92.3198 15.5678C93.6423 22.9006 98.0909 29.1516 103.141 34.5009C104.824 36.3041 106.567 37.987 108.431 39.6099C110.535 41.413 112.699 43.1561 115.164 44.4183C115.645 44.6587 117.027 45.5603 117.629 45.38C118.47 45.1395 119.492 43.2162 120.093 42.6151C122.438 40.271 125.384 38.5881 128.449 37.386C129.051 37.1456 130.854 36.244 131.575 36.5445C131.696 36.6046 129.351 38.9487 129.231 39.129C127.728 40.7519 126.285 42.4348 124.963 44.238C122.738 47.1831 120.755 50.3086 119.252 53.6745C118.951 54.3356 118.23 57.3409 117.448 57.6414C116.667 57.942 114.442 56.1989 113.901 55.8984C110.174 53.6745 106.687 51.2102 103.441 48.4453C94.7845 40.8721 88.8932 30.2936 87.4504 18.9337C86.6689 13.1035 87.5105 6.3717 91.5984 1.80371L94.5441 4.74886Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 8,
    width: 44,
    height: 43
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M134.16 41.3527C134.22 41.8936 133.739 40.3309 133.499 39.85C132.958 38.8282 132.297 37.8666 131.695 36.9049C129.892 34.2001 127.968 31.4954 125.924 28.971C119.672 21.3977 111.557 15.3872 102.72 11.0596C100.255 9.85754 95.6259 6.85228 92.9207 8.89585C89.2536 11.7208 92.4398 22.3594 93.582 25.8455C97.4895 37.566 111.196 49.8275 124.842 50.0679L134.16 41.3527Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.178 48.0842C132.298 47.964 130.916 46.0406 130.795 45.9204C129.172 43.5763 127.369 41.4125 125.505 39.3088C120.395 33.4786 114.384 27.7686 107.591 24.2224C106.689 23.7416 105.727 23.2607 104.705 22.9001C102.721 22.1187 99.4149 21.5778 100.136 24.9437C100.257 25.4846 100.437 25.9655 100.617 26.5064C102.06 30.1127 104.585 33.3584 107.23 36.0631C109.695 38.5875 112.64 40.571 115.586 42.3742C119.914 45.0188 124.543 46.5815 129.172 48.565L132.178 48.0842Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 22,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 22,
    width: 33,
    height: 27
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M132.178 48.0842C132.298 47.964 130.916 46.0406 130.795 45.9204C129.172 43.5763 127.369 41.4125 125.505 39.3088C120.395 33.4786 114.384 27.7686 107.591 24.2224C106.689 23.7416 105.727 23.2607 104.705 22.9001C102.721 22.1187 99.4149 21.5778 100.136 24.9437C100.257 25.4846 100.437 25.9655 100.617 26.5064C102.06 30.1127 104.585 33.3584 107.23 36.0631C109.695 38.5875 112.64 40.571 115.586 42.3742C119.914 45.0188 124.543 46.5815 129.172 48.565L132.178 48.0842Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.16 41.3527C134.22 41.8936 133.739 40.3309 133.499 39.85C132.958 38.8282 132.297 37.8666 131.695 36.9049C129.892 34.2001 127.968 31.4954 125.924 28.971C119.672 21.3977 111.557 15.3872 102.72 11.0596C100.255 9.85754 95.6259 6.85228 92.9207 8.89585C89.2536 11.7208 92.4398 22.3594 93.582 25.8455C97.4895 37.566 111.196 49.8275 124.842 50.0679L134.16 41.3527Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5441 4.74789C94.4839 4.32715 94.003 5.40905 93.7626 5.82978C93.3417 6.55104 93.1013 7.39252 92.8608 8.17388C92.2597 10.5781 91.899 13.1626 92.3198 15.5668C93.6423 22.8997 98.0909 29.1506 103.141 34.5C104.824 36.3031 106.567 37.9861 108.431 39.6089C110.535 41.412 112.699 43.1551 115.164 44.4173C115.645 44.6577 117.027 45.5593 117.629 45.379C118.47 45.1386 119.492 43.2152 120.093 42.6142C122.438 40.2701 125.384 38.5871 128.449 37.385C129.051 37.1446 130.854 36.243 131.575 36.5435C131.696 36.6036 129.351 38.9477 129.231 39.1281C127.728 40.7509 126.285 42.4338 124.963 44.237C122.738 47.1821 120.755 50.3076 119.252 53.6735C118.951 54.3347 118.23 57.3399 117.448 57.6404C116.667 57.941 114.442 56.1979 113.901 55.8974C110.174 53.6735 106.687 51.2092 103.441 48.4444C94.7845 40.8711 88.8932 30.2926 87.4504 18.9327C86.6689 13.1025 87.5105 6.37073 91.5984 1.80273L94.5441 4.74789Z",
    fill: "#EEC18F"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.231 176.169C136.747 176.469 87.2717 156.334 96.7099 105.906C110.056 34.08 136.507 29.0913 159.531 28.4902H160.072C182.916 29.1514 209.067 34.621 222.352 105.906C231.73 156.574 181.834 176.65 159.531 176.169H159.231Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 28,
    width: 129,
    height: 149
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.231 176.169C136.747 176.469 87.2717 156.334 96.7099 105.906C110.056 34.08 136.507 29.0913 159.531 28.4902H160.072C182.916 29.1514 209.067 34.621 222.352 105.906C231.73 156.574 181.834 176.65 159.531 176.169H159.231Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.98 57.3412C125.747 31.4959 143.481 28.9114 159.472 28.5508H160.013C175.884 29.0316 193.377 31.7965 206.964 57.3412C193.137 34.381 175.824 31.7965 160.013 31.3757H159.472C143.541 31.7364 125.987 34.0805 111.98 57.3412Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 28,
    width: 129,
    height: 149
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M159.231 176.169C136.747 176.469 87.2717 156.334 96.7099 105.906C110.056 34.08 136.507 29.0913 159.531 28.4902H160.072C182.916 29.1514 209.067 34.621 222.352 105.906C231.73 156.574 181.834 176.65 159.531 176.169H159.231Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.896 59.3848C106.447 69.6628 102.48 83.0662 99.2937 100.497C98.8728 102.66 98.6324 104.764 98.452 106.808C97.6705 108.911 97.1896 111.256 97.1896 113.9C97.1896 153.029 125.083 170.159 159.47 170.159C193.856 170.159 221.75 153.029 221.75 113.9C221.75 111.316 221.329 108.972 220.487 106.868C220.307 104.824 220.006 102.66 219.646 100.497C216.46 83.0662 212.552 69.7229 208.043 59.3848C213.574 70.4441 218.443 85.4704 222.231 105.906C222.652 108.13 222.952 110.294 223.133 112.398C223.974 114.561 224.395 116.905 224.395 119.61C224.395 159.64 195.299 177.131 159.41 177.131C123.52 177.131 94.4844 159.64 94.4844 119.61C94.4844 116.966 94.9653 114.561 95.8069 112.398C95.9873 110.294 96.2879 108.13 96.7087 105.966C100.496 85.4704 105.365 70.4441 110.896 59.3848Z",
    fill: "#CE8710"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M159.891 93.043C180.45 93.043 224.515 93.5238 224.515 119.609C224.515 159.64 195.419 177.13 159.53 177.13C123.641 177.13 94.4844 159.64 94.4844 119.609C94.4844 93.1031 139.331 93.043 159.891 93.043Z",
    fill: "#F6DCBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_197_182031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 93,
    width: 131,
    height: 85
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.891 93.043C180.45 93.043 224.515 93.5238 224.515 119.609C224.515 159.64 195.419 177.13 159.53 177.13C123.641 177.13 94.4844 159.64 94.4844 119.609C94.4844 93.1031 139.331 93.043 159.891 93.043Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_197_182031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.896 59.3838C106.447 69.6618 102.48 83.0652 99.2937 100.496C98.8728 102.66 98.6324 104.763 98.452 106.807C97.6705 108.91 97.1896 111.255 97.1896 113.899C97.1896 153.028 125.083 170.158 159.47 170.158C193.856 170.158 221.75 153.028 221.75 113.899C221.75 111.315 221.329 108.971 220.487 106.867C220.307 104.823 220.006 102.66 219.646 100.496C216.46 83.0652 212.552 69.7219 208.043 59.3838C213.574 70.4431 218.443 85.4694 222.231 105.905C222.652 108.129 222.952 110.293 223.133 112.397C223.974 114.56 224.395 116.904 224.395 119.609C224.395 159.639 195.299 177.13 159.41 177.13C123.52 177.13 94.4844 159.639 94.4844 119.609C94.4844 116.965 94.9653 114.56 95.8069 112.397C95.9873 110.293 96.2879 108.129 96.7087 105.965C100.496 85.4694 105.365 70.4431 110.896 59.3838Z",
    fill: "#EEC18F"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.22 58.002C143.298 58.002 150.632 65.455 150.632 74.6511C150.632 83.8472 143.298 91.3002 134.22 91.3002C125.143 91.3002 117.809 83.8472 117.809 74.6511C117.809 65.455 125.203 58.002 134.22 58.002Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.221 63.6514C140.834 63.6514 146.184 69.0608 146.184 75.7325C146.184 82.4042 140.834 87.8137 134.221 87.8137C127.608 87.8137 122.258 82.4042 122.258 75.7325C122.258 69.0608 127.668 63.6514 134.221 63.6514Z",
    fill: "#301007"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.684 67.2574C137.586 66.5962 139.389 67.5579 140.772 69.4212C142.155 71.2844 142.576 73.328 141.674 73.9892C140.772 74.6503 138.969 73.6887 137.586 71.8254C136.203 69.9621 135.843 67.9186 136.684 67.2574Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.975 75.9727C142.997 75.9727 143.779 76.8141 143.779 77.7758C143.779 78.7976 142.997 79.579 141.975 79.579C140.953 79.579 140.172 78.7375 140.172 77.7758C140.172 76.8141 141.013 75.9727 141.975 75.9727Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.779 58.002C193.856 58.002 201.19 65.455 201.19 74.6511C201.19 83.8472 193.856 91.3002 184.779 91.3002C175.701 91.3002 168.367 83.8472 168.367 74.6511C168.367 65.455 175.701 58.002 184.779 58.002Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.779 63.6514C178.167 63.6514 172.816 69.0608 172.816 75.7325C172.816 82.4042 178.167 87.8137 184.779 87.8137C191.392 87.8137 196.743 82.4042 196.743 75.7325C196.743 69.0608 191.392 63.6514 184.779 63.6514Z",
    fill: "#301007"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.314 67.2574C181.412 66.5962 179.609 67.5579 178.226 69.4212C176.843 71.2844 176.422 73.328 177.324 73.9892C178.226 74.6503 180.029 73.6887 181.412 71.8254C182.795 69.9621 183.216 67.9186 182.314 67.2574Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.022 75.9727C176 75.9727 175.219 76.8141 175.219 77.7758C175.219 78.7976 176 79.579 177.022 79.579C178.044 79.579 178.826 78.7375 178.826 77.7758C178.826 76.8141 177.984 75.9727 177.022 75.9727Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.173 55.1164C202.573 59.0233 209.486 65.6348 207.623 69.9624C205.759 74.29 195.72 74.5905 185.32 70.7438C174.92 66.8369 168.006 60.2254 169.87 55.8978C171.794 51.6303 181.773 51.2697 192.173 55.1164Z",
    fill: "#E4B637"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.827 55.1164C116.427 59.0233 109.514 65.6348 111.378 69.9624C113.241 74.29 123.281 74.5905 133.681 70.7438C144.081 66.8369 150.994 60.2254 149.13 55.8978C147.267 51.6303 137.228 51.2697 126.827 55.1164Z",
    fill: "#E4B637"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.39 36.6045C141.855 36.6045 143.839 38.588 143.839 41.0523C143.839 43.5166 141.855 45.5001 139.39 45.5001C136.925 45.5001 134.941 43.5166 134.941 41.0523C134.941 38.588 136.925 36.6045 139.39 36.6045Z",
    fill: "#673620"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.077 45.5C165.542 45.5 167.526 47.4835 167.526 49.9478C167.526 52.4121 165.542 54.3956 163.077 54.3956C160.613 54.3956 158.629 52.4121 158.629 49.9478C158.629 47.4835 160.613 45.5 163.077 45.5Z",
    fill: "#673620"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.812 36.6045C182.856 36.6045 184.479 38.2273 184.479 40.2709C184.479 42.3145 182.856 43.9373 180.812 43.9373C178.768 43.9373 177.145 42.3145 177.145 40.2709C177.145 38.2273 178.768 36.6045 180.812 36.6045Z",
    fill: "#673620"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.736 33.178C155.502 32.8173 158.087 34.8609 158.447 37.746C158.808 40.631 156.884 43.2756 154.119 43.6363C151.354 43.9969 148.769 41.9533 148.408 39.0683C147.987 36.1832 149.971 33.5386 152.736 33.178Z",
    fill: "#673620"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.053 53.4336C152.556 53.4336 153.758 54.6357 153.758 56.1383C153.758 57.641 152.556 58.8431 151.053 58.8431C149.55 58.8431 148.348 57.641 148.348 56.1383C148.348 54.6958 149.55 53.4336 151.053 53.4336Z",
    fill: "#673620"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.949 47.0022C149.791 47.1224 150.452 47.8437 150.332 48.7452C150.211 49.5867 149.49 50.2479 148.588 50.1277C147.747 50.0074 147.085 49.2862 147.206 48.3846C147.326 47.5431 148.107 46.9421 148.949 47.0022Z",
    fill: "#673620"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.891 41.292C171.733 41.292 172.454 42.0133 172.454 42.8547C172.454 43.6962 171.733 44.4175 170.891 44.4175C170.05 44.4175 169.328 43.6962 169.328 42.8547C169.328 41.9532 170.05 41.292 170.891 41.292Z",
    fill: "#673620"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.368 55.8379C169.209 55.8379 169.931 56.5592 169.931 57.4006C169.931 58.2421 169.209 58.9634 168.368 58.9634C167.526 58.9634 166.805 58.2421 166.805 57.4006C166.805 56.5592 167.526 55.8379 168.368 55.8379Z",
    fill: "#673620"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.744 32.998C168.247 32.998 169.449 34.2002 169.449 35.7028C169.449 37.2054 168.247 38.4075 166.744 38.4075C165.241 38.4075 164.039 37.2054 164.039 35.7028C164.039 34.2002 165.241 32.998 166.744 32.998Z",
    fill: "#673620"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.693 49.3467C140.955 49.3467 141.917 50.3685 141.917 51.5706C141.917 52.8328 140.895 53.7945 139.693 53.7945C138.431 53.7945 137.469 52.7727 137.469 51.5706C137.469 50.3084 138.491 49.3467 139.693 49.3467Z",
    fill: "#673620"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.53 59.624C161.574 59.624 163.197 61.2469 163.197 63.2904C163.197 65.334 161.574 66.9569 159.53 66.9569C157.486 66.9569 155.863 65.334 155.863 63.2904C155.863 61.2469 157.486 59.624 159.53 59.624Z",
    fill: "#673620"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.304 48.1445C177.747 48.1445 178.889 49.2865 178.889 50.7291C178.889 52.1716 177.747 53.3136 176.304 53.3136C174.861 53.3136 173.719 52.1716 173.719 50.7291C173.719 49.2865 174.921 48.1445 176.304 48.1445Z",
    fill: "#673620"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.443 103.741C146.066 103.08 148.47 104.763 149.853 107.468C151.236 110.173 151.055 112.938 149.492 113.599C147.869 114.26 145.465 112.577 144.082 109.872C142.699 107.167 142.88 104.403 144.443 103.741Z",
    fill: "#301007"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.559 103.741C172.936 103.08 170.531 104.763 169.148 107.468C167.766 110.173 167.946 112.938 169.509 113.599C171.132 114.26 173.537 112.577 174.92 109.872C176.302 107.167 176.182 104.403 174.559 103.741Z",
    fill: "#301007"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.364 87.4531C205.518 87.4531 211.349 89.1361 211.349 91.2398C211.349 93.3434 205.518 95.0264 198.364 95.0264C191.21 95.0264 185.379 93.3434 185.379 91.2398C185.379 89.1361 191.21 87.4531 198.364 87.4531Z",
    fill: "#4781E3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.512 88.4148C204.797 88.6552 206.6 89.1961 206.48 89.5568C206.42 89.9174 204.496 89.9775 202.212 89.7371C199.927 89.4967 198.124 88.9557 198.244 88.5951C198.304 88.2344 200.228 88.1743 202.512 88.4148Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.044 89.376C208.405 89.376 208.705 89.5563 208.705 89.8568C208.705 90.0972 208.405 90.3377 208.044 90.3377C207.683 90.3377 207.383 90.1573 207.383 89.8568C207.383 89.6164 207.683 89.376 208.044 89.376Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.696 87.4531C113.542 87.4531 107.711 89.1361 107.711 91.2398C107.711 93.3434 113.542 95.0264 120.696 95.0264C127.85 95.0264 133.681 93.3434 133.681 91.2398C133.621 89.1361 127.85 87.4531 120.696 87.4531Z",
    fill: "#4781E3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.548 88.4148C114.263 88.6552 112.46 89.1961 112.58 89.5568C112.64 89.9174 114.564 89.9775 116.848 89.7371C119.133 89.4967 120.936 88.9557 120.816 88.5951C120.756 88.2344 118.832 88.1743 116.548 88.4148Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.958 89.376C110.597 89.376 110.297 89.5563 110.297 89.8568C110.297 90.0972 110.597 90.3377 110.958 90.3377C111.319 90.3377 111.619 90.1573 111.619 89.8568C111.619 89.6164 111.319 89.376 110.958 89.376Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.495 146.596C144.801 144.372 148.649 143.11 152.676 142.329C155.201 141.848 157.846 141.667 160.431 141.667C161.453 141.667 162.475 141.667 163.557 141.728C165.12 141.788 166.683 141.968 168.186 142.269C172.094 142.99 175.881 144.372 179.188 146.716C179.548 147.017 180.029 146.957 180.33 146.656C180.63 146.296 180.57 145.815 180.27 145.514C177.204 142.208 173.416 139.744 169.268 138.241C167.585 137.64 165.782 137.22 164.038 136.919C162.836 136.739 161.634 136.619 160.431 136.679C157.426 136.739 154.42 137.28 151.594 138.241C147.326 139.744 143.599 142.148 140.473 145.274C140.112 145.574 140.052 146.055 140.353 146.416C140.653 146.837 141.134 146.897 141.495 146.596Z",
    fill: "#301007"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_182031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 320,
    fill: "white",
    transform: "translate(61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeSad);
export default __webpack_public_path__ + "static/media/giraffe_sad.39d773244d4312cc4fa77527e8fd141d.svg";
export { ForwardRef as ReactComponent };